package org.example.project.settings

import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Color

object UISettings {
    const val ACCENT_HEX = "#A21D35"
    val ACCENT: CSSColorValue = Color(ACCENT_HEX)
    const val LOGIN_BUTTON_BG = "#54111D"
    const val SALES_KPI_BG = "#30343a"
    fun accentRgba(alpha: Double): String {
        val rgb = ACCENT_HEX.removePrefix("#").toInt(16)
        return "rgba(${(rgb shr 16) and 255},${(rgb shr 8) and 255},${rgb and 255},$alpha)"
    }
    val TABULAR_HOVER_BG: CSSColorValue = Color(accentRgba(0.10))
    val TABULAR_SELECTED_BG: CSSColorValue = Color(accentRgba(0.18))
    val STATE_BUTTON_TEXT: CSSColorValue = Color("#d7dde8")
    val STATE_BUTTON_ACTIVE_TEXT: CSSColorValue = Color("#f7f7f5")
    const val BLUE_SURFACE_GRADIENT =
        "linear-gradient(135deg, rgba(91,155,255,0.45) 0%, rgba(22,26,34,0.95) 70%), linear-gradient(45deg, rgba(255,255,255,0.08), rgba(255,255,255,0.0))"
    const val STATE_BUTTON_ICON_FILTER = "brightness(0) invert(1)"
    const val ICON_FILTER_ACCENT =
        "brightness(0) saturate(100%) invert(19%) sepia(55%) saturate(2426%) hue-rotate(325deg) brightness(86%) contrast(94%)"
    const val STATE_BUTTON_ACTIVE_ICON_FILTER = ICON_FILTER_ACCENT
}

